import type { InjectionKey, Ref } from 'vue'

export type AnchorContext = {
  activeLink: Ref<string>
  addLink: (href: string, element) => void
  removeLink: (href: string) => void
  handleClick: (e: Event, info: { title: any, href: string }) => void
}

export const AnchorContextKey: InjectionKey<AnchorContext> = Symbol('AnchorContextKey')!
